import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "./common.service";
import { ApiService } from "./api.service";
import { AbilityConfig } from "./ability-config/ability-config";
import {OpenClassConfig} from './openClass-config/openClass-config';

declare var $: any;

@Component({
	selector: 'app-learning-map-open-class',
	templateUrl: './learning-map-open-class.component.html',
	styleUrls: ['./learning-map-open-class.component.css', ]
})
export class LearningMapOpenClassComponent implements OnInit, AfterViewInit {

	//学习地图信息
	@Input() learningTour: any;
	@Input() methodId:any;

	learningPath: any;
  abilityConfig: AbilityConfig;
  openClassConfig: OpenClassConfig;
  practiceList: any;
  practiceId: number;
  learningPathMetaName: string;
  abilityClassIds: any;



	constructor(private route: ActivatedRoute,
		private router: Router,
		private apiService: ApiService,
		private commonService: CommonService) {}

	ngOnInit() {
	  this.showPreSurvey();

	 //  let that = this;
    // this.abilityConfig = new AbilityConfig(this.apiService);
    // this.openClassConfig = new OpenClassConfig(this.apiService);
    //
    // this.learningPathMetaName = this.openClassConfig.getLearningPathMetaName(this.methodId);
    // this.abilityClassIds = this.openClassConfig.getAbilityIds(this.learningPathMetaName);
    //
    //
    // this.openClassConfig.getLearningPath(this.abilityClassIds.learningPathMetaId).subscribe(result=>{
    //   that.learningPath = result;
    //
    //   if(that.methodId.toString()===that.abilityClassIds.abilityHostId.toString()+"1"){
    //     localStorage.setItem('openClass','1');
    //     that.showPreSurvey();
    //   }else if(that.methodId.toString()===that.abilityClassIds.abilityHostId.toString()+"2" || that.methodId.toString()===that.abilityClassIds.abilityHostId.toString()+"4"){
    //     localStorage.setItem('openClass','1');
    //     this.showPractice(this.methodId);
    //   }else if(that.methodId.toString()===that.abilityClassIds.abilityHostId.toString()+"3"){
    //     localStorage.setItem('openClass','1');
    //     that.openClassConfig.getPostSurvey(that.abilityClassIds.learningPathMetaId).subscribe(param=>{
    //       that.showPostSurvey(param.finishFlag);
    //     });
    //   }
    // })
	}

	showPreSurvey(){
	  // let link = ['ability-survey', this.abilityClassIds.learningPathMetaId, 1];
    let link = ['ability-survey', this.methodId, 1];
    this.router.navigate(link);
  }

  // showPractice(methodId){
  //   let link;
  //   if(methodId==722){
  //     link = [this.learningPath.id, '1', 'case-practice-coach'];
  //   }else{
  //     link = this.abilityConfig.getPracticeLinkList(this.learningPath.name,this.learningPath.id,this.abilityClassIds.practiceMetaId);
  //   }
  //   console.log(link.length);
  //   if(link.length > 0){
  //     this.router.navigate(link);
  //   }
  // }

  // showPostSurvey(param){
  //   if(param){
  //     let link = ['ability-survey', this.abilityClassIds.learningPathMetaId, 2];
  //     this.router.navigate(link);
  //   }else{
  //     $("#tip1").fadeIn(500);
  //   }
  // }

	ngAfterViewInit() {
		this.commonService.initPage();
	}

}



// WEBPACK FOOTER //
// ./src/app/learning-map-open-class.component.ts